import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import WorkLogPage from "@/pages/WorkLogPage";
import ReelsPage from "@/pages/ReelsPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import ResearchPage from "@/pages/ResearchPage";
import SettingsPage from "@/pages/SettingsPage";
import ReviewPage from "@/pages/ReviewPage";
import PersonasPage from "@/pages/PersonasPage";
import LeadsPage from "@/pages/LeadsPage";
import LandingPagePublic from "@/pages/LandingPagePublic";
import AuleloLogin from "@/pages/aulelo/AuleloLogin";
import AuleloShell from "@/pages/aulelo/AuleloShell";
import AuleloBriefing from "@/pages/aulelo/AuleloBriefing";
import AuleloWorld from "@/pages/aulelo/AuleloWorld";
import AuleloTours from "@/pages/aulelo/AuleloTours";
import AuleloVault from "@/pages/aulelo/AuleloVault";
import AuleloPodcast from "@/pages/aulelo/AuleloPodcast";
import AuleloVasa from "@/pages/aulelo/AuleloVasa";
import AuleloWatchlist from "@/pages/aulelo/AuleloWatchlist";
import AuleloFirstLogin from "@/pages/aulelo/AuleloFirstLogin";
import AuleloGate from "@/pages/aulelo/AuleloGate";
import ManchiLogin from "@/pages/manchi/ManchiLogin";
import ManchiShell from "@/pages/manchi/ManchiShell";
import ManchiCompose from "@/pages/manchi/ManchiCompose";
import ManchiDaily from "@/pages/manchi/ManchiDaily";
import ManchiWorld from "@/pages/manchi/ManchiWorld";
import ManchiSources from "@/pages/manchi/ManchiSources";
import ManchiDrafts from "@/pages/manchi/ManchiDrafts";
import ManchiVault from "@/pages/manchi/ManchiVault";
import { AuthProvider, useAuth } from "@/context/AuthContext";

function PrivateRoute({ children }) {
  const { token, loading } = useAuth();
  if (loading) return null;
  if (!token) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/admin/worklog" element={<PrivateRoute><WorkLogPage /></PrivateRoute>} />
            <Route path="/admin/reels" element={<PrivateRoute><ReelsPage /></PrivateRoute>} />
            <Route path="/admin/analytics" element={<PrivateRoute><AnalyticsPage /></PrivateRoute>} />
            <Route path="/admin/research" element={<PrivateRoute><ResearchPage /></PrivateRoute>} />
            <Route path="/admin/settings" element={<PrivateRoute><SettingsPage /></PrivateRoute>} />
            <Route path="/admin/personas" element={<PrivateRoute><PersonasPage /></PrivateRoute>} />
            <Route path="/admin/leads" element={<PrivateRoute><LeadsPage /></PrivateRoute>} />
            <Route path="/review/:token" element={<ReviewPage />} />
            <Route path="/p/:slug" element={<LandingPagePublic />} />

            {/* Aulelo — secret news agent */}
            <Route path="/aulelo/first-login" element={<AuleloFirstLogin />} />
            <Route path="/aulelo/console" element={<AuleloShell />}>
              <Route index element={<AuleloBriefing />} />
              <Route path="world" element={<AuleloWorld />} />
              <Route path="tours" element={<AuleloTours />} />
              <Route path="vasa" element={<AuleloVasa />} />
              <Route path="watchlist" element={<AuleloWatchlist />} />
              <Route path="podcast" element={<AuleloPodcast />} />
              <Route path="settings" element={<AuleloVault />} />
            </Route>
            {/* ManchiGirl — economics & finance LinkedIn studio */}
            <Route path="/manchi" element={<ManchiLogin />} />
            <Route path="/manchi/studio" element={<ManchiShell />}>
              <Route index element={<ManchiCompose />} />
              <Route path="daily" element={<ManchiDaily />} />
              <Route path="globe" element={<ManchiWorld />} />
              <Route path="sources" element={<ManchiSources />} />
              <Route path="drafts" element={<ManchiDrafts />} />
              <Route path="vault" element={<ManchiVault />} />
            </Route>

            {/* Passkey URL — must come AFTER all named routes so they take precedence */}
            <Route path="/:secret" element={<AuleloGate />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="light"
          position="top-right"
          toastOptions={{
            classNames: {
              toast: "bg-white border border-hairline text-bone font-sans",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
